import { launch } from 'shared/helper/serviceLauncher';
import { requestLaunchExternalLink, setTituloPagina, setIsMenuActive, setSolicitandoMenu, getMenuPrincipalFromGestao } from 'painel/actions';
import { TK_TIPOS_ACAO_SELECAO_SERVICO, trackServiceSelectORA } from 'shared/helper/tracker';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useMemo, useRef, useState } from 'react';
import history from '../../../history';
import './menu.css';
import { deslogarUsuario } from 'login/actions';
import { removeNotificationToken } from 'apps/notificacao/registroNotificacao';
import { openLogoutUrl } from 'platformImpl';
const Menu = ({
  id,
}) => {

  const dispatch = useDispatch();
  const isMenuActive = useSelector(state => state.app.isMenuActive);
  const menuItems = useSelector(state => state.app.menuItems);
  const [openFolders, setOpenFolders] = useState({});
  const primeiroItemRef = useRef(null);

    useEffect(() => {
      dispatch(setSolicitandoMenu(true));
      dispatch(getMenuPrincipalFromGestao());
    }, []);


  const handleSairClick = () => {
    localStorage.removeItem('ifs_auth');
    localStorage.removeItem('ifs_ts');
    sessionStorage.removeItem('initTrack');
    removeNotificationToken();
    openLogoutUrl();
  }

  const menuItemsExibir = useMemo( () => {

    const servicoFixoInicio = {
      tipoServico: 1,
      isAtivo: true,
      path: '/',
      rota: '/',
      tipo: 'SERVICO',
      titulo: 'Início',
      tituloCurto: 'Início'
    }

    if (!menuItems) return [servicoFixoInicio];
  
    return [
      servicoFixoInicio,
      ...menuItems
    ];
  }, [menuItems]);

  const footerItems = [
    {
      titulo: "Autenticidade de Documentos",
      rota: "/aberto/autenticidade",
      tipoServico: 1 //INSS
    },
    {
      titulo: "Política de Privacidade",
      linkExterno: "https://www.gov.br/inss/pt-br/canais_atendimento/saiba-tudo-sobre-o-meu-inss/politica-de-privacidade-do-meu-inss",

    },
    {
      titulo: "Acessibilidade",
      rota: "/aberto/acessibilidade",
      tipoServico: 1
    },
    {
      titulo: "Sobre",
      rota: "/aberto/sobre",
      tipoServico: 1
    },
    {
      titulo: "Sair do Meu INSS",
      action: handleSairClick
    },
  ]

  useEffect(() => {
    if (primeiroItemRef.current) {
      if (!openFolders[primeiroItemRef.current.getAttribute('itemkey')]) {
        primeiroItemRef.current.focus();
      }
    }
  }, [primeiroItemRef.current]);

  const toggleFolder = (index) => {
    setOpenFolders((prev) => ({ ...Object.keys(prev).map(i => { return { [i]: !prev[i] } }), [index]: !prev[index] }));
  };

  const toggleMenu = () => {
    if (isRootLocation()) {
      dispatch(setIsMenuActive(!isMenuActive));
    } else {
      dispatch(setTituloPagina("Meu INSS"));
      history.push('/');
    }
  };

  const MenuFolder = ({ renderFolder = false, children }) => {
    return (
      <div className={`${renderFolder ? 'menu-folder' : ''}`}>
        {children}
      </div>
    );
  };

  const handleItemClick = (item, itemKey, level) => {
    if ((item.subItens || []).length > 0 && level < 1) {
      const wasOpen = openFolders[itemKey];
      toggleFolder(itemKey);
      
      if(!wasOpen){
        setTimeout(()=>{
          const parentLi = document.querySelector(`[itemkey="${itemKey}"]`).closest('li')
          const firstSubItem = parentLi ? parentLi.querySelector('ul > li') : null
          if(firstSubItem){
            const focusableElement = firstSubItem.querySelector('[tabindex]');
            if (focusableElement){
              focusableElement.focus();
            }
          }
        },0);
      } else {
        setTimeout(() => {
          const parentItem = document.querySelector(`[itemkey="${itemKey}"]`);
          if(parentItem){
            parentItem.focus();
          }
        }, 0);
      }
    }else {
      launch(item, "MENU");
      trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.MENU, item.titulo);
      dispatch(setIsMenuActive(false));
    }
  }

  const handleItemKeyDown = (event, item, itemKey, level) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleItemClick(item, itemKey, level);
    } else if (event.key === "ArrowDown") {
      event.preventDefault();
      const allVisibleItems = document.querySelectorAll('.menu-item[itemkey]:not([style*="display: none"])');
      const currentIndex = Array.from(allVisibleItems).findIndex(el => el.getAttribute('itemkey') === itemKey);
      const nextItem = allVisibleItems[currentIndex + 1];
      if(nextItem){
        nextItem.focus();
      }
    }else if (event.key === "ArrowUp"){
      event.preventDefault();
      const allVisibleItems = document.querySelectorAll('.menu-item[itemkey]:not([style*="display: none"])');
      const currentIndex = Array.from(allVisibleItems).findIndex(el => el.getAttribute('itemkey') === itemKey);
      const prevItem = allVisibleItems[currentIndex - 1];
      if(prevItem){
        prevItem.focus();
      }
    }else if (event.key === "ArrowRight" && level === 0){
      event.preventDefault();
      const hasSubItem = (item.subItens || []).length > 0;
      if(hasSubItem && !openFolders[itemKey]){
        toggleFolder(itemKey);
        setTimeout(() => {
          const firstSubItem = document.querySelector(`[itemkey="${itemKey.split('-')[0]}-${itemKey.split('-')[1]}"] ~ ul [itemkey]`);
          if(firstSubItem){
            firstSubItem.focus();
          }
        }, 0);
      }
    }else if (event.key === "ArrowLeft" && level > 0){
      event.preventDefault();
      const parentKey = `${level-1}-${itemKey.split('-')[1]}`;
      const parentItem = document.querySelector(`[itemkey="${parentKey}"]`);
      if(parentItem){
        parentItem.focus();
      }
    }else if (event.key === "Escape"){
      event.preventDefault();
      if(level > 0){
        const parentKey = `${level-1}-${itemKey.split('-')[1]}`;
        const parentItem = document.querySelector(`[itemkey="${parentKey}"]`);
        if(parentItem){
          parentItem.focus();
        }
      }
    }
  };

  const renderMenuItem = (item, itemKey, level = 0, parentTitleId = null, subMenuId = null) => {
    if (item) {
      const hasSubItem = (item.subItens || []).length > 0 && level < 1
      const isExpanded = openFolders[itemKey] || false
      return (
        <a tabIndex={0}
          itemkey={itemKey}
          ref={itemKey === '1-0' ? primeiroItemRef : null}
          title={item.titulo}
          className="menu-item"
          role="menuitem"
          id={`menu-item-${itemKey}`}
          aria-haspopup={hasSubItem ? "menu" : undefined}
          aria-expanded={hasSubItem ? isExpanded : undefined}
          aria-label={hasSubItem ? `${item.titulo}, ${isExpanded ? 'expandido' : 'recolhido'}` : item.titulo}
          onBlur={(event) => event.target.classList.remove('focus-visible')} 
          onClick={(event) => {
            event.preventDefault();
            handleItemClick(item, itemKey, level)
          }
          }
          onKeyDown={(event) => handleItemKeyDown(event, item, itemKey, level)}
        >
          <span className="content">{item.tituloCurto || item.titulo}</span>
          {hasSubItem && (
            (item.subItens || []).length > 0 && level < 1 &&
            <div className='support'>
              <i
                className={`expand-icon fas ${openFolders[itemKey] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}`}
                aria-hidden="true"></i>
            </div>
          )}
        </a>
      );
    } else {
      return <></>
    }
  };

  const renderMenuItems = (items, level = 0, parentTitleId = null) => {
    return (
      <ul role={level === 0 ? "menubar" : "menu"} aria-label={level === 0 ? "Menu principal" : undefined}>
        {items.map((item, index) => {
          if (!!item && item.isAtivo) {
            let folderKey = `${level}-${index}`;
            const titleId = `menu-title-${folderKey}`;
            const subMenuId = `submenu-${folderKey}`
            return (
              <li key={index} role="none"> 
                <MenuFolder renderFolder={level == 0}>
                  <>
                    {renderMenuItem(item, folderKey, level, parentTitleId, subMenuId)}
                    {
                      level < 1 && item.subItens && item.subItens.length > 0 && 
                        openFolders[folderKey] && (
                          <ul id={subMenuId} role="menu" aria-label={`Submenu de ${item.titulo}`}>
                            {renderMenuItems(item.subItens, level + 1, titleId)}
                          </ul>
                        )
                    }
                  </>
                </MenuFolder>
              </li>
            )
          }
        })}
      </ul>
    );
  };

  const handleLinkClick = (item) => {
    console.debug("handleLinkClick", item)
    if (item.rota) {
      launch(item, "MENU");
    } else if (item.action) {
      item.action()
    } else if (item.linkExterno) {
      dispatch(requestLaunchExternalLink(item.linkExterno));
    }
    trackServiceSelectORA(TK_TIPOS_ACAO_SELECAO_SERVICO.MENU, item.titulo);
    dispatch(setIsMenuActive(false));
  }

  const handleLinkKeyDown = (event, item, index) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleLinkClick(item);
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      event.preventDefault();
      const footerLinks = document.querySelectorAll('.menu-footer [role="menuitem"]');
      const nextIndex = (index + 1) % footerLinks.length;
      footerLinks[nextIndex].focus();
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      event.preventDefault();
      const footerLinks = document.querySelectorAll('.menu-footer [role="menuitem"]');
      const prevIndex = (index - 1 + footerLinks.length) % footerLinks.length;
      footerLinks[prevIndex].focus();
    } else if (event.key === 'Home') {
      event.preventDefault();
      const footerLinks = document.querySelectorAll('.menu-footer [role="menuitem"]');
      footerLinks[0].focus();
    } else if (event.key === 'End') {
      event.preventDefault();
      const footerLinks = document.querySelectorAll('.menu-footer [role="menuitem"]');
      footerLinks[footerLinks.length - 1].focus();
    }
  };

  const renderFooterLinks = (items) => {
    return (
      <nav className="menu-links" role="menubar" aria-label="Links do rodapé">
        {items.map((item, index) => (
          <a tabIndex={0} title={item.titulo} key={index} role='menuitem'
            aria-label={item.titulo}
            onClick={(e) => {
              e.preventDefault();
              handleLinkClick(item)
            }
            }
            onKeyDown={(e) => handleLinkKeyDown(e, item, index)}>
            <span className="mr-1">{item.titulo}</span>
          </a>
        ))}
      </nav>
    );
  };

  const isRootLocation = () => {
    const location = window.location.hash.substring(1);
    return location === '/' || location.startsWith('/?origem-click=');
  }

  return (
    <div role='region' aria-label='Menu principal' className={`br-menu ${isMenuActive ? 'active' : ''}`} id={id} >
      <div className='btn-toggle-menu'>
        <button onClick={toggleMenu} id='btn-toggle-menu' aria-expanded={isMenuActive} className="br-button circle" type="button" aria-label="Menu" data-toggle="menu" data-target={`#${id}`}>
          <i className={`fas ${isMenuActive || !isRootLocation() ? 'fa-arrow-left' : 'fa-bars'} `} aria-hidden="true"></i>
        </button>
      </div>
      <div className="menu-container">
        <div className="menu-panel">
          <div className="menu-header justify-content-end">
            <div className="menu-close">
              <button
                className="br-button circle"
                type="button"
                aria-label="Fechar o menu"
                data-dismiss="menu"
                onClick={toggleMenu}
              >
                <i className="fas fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <nav className="menu-body" aria-label='navegação menu principal' tabIndex={-1} id='menu'>
            {renderMenuItems(menuItemsExibir)}
          </nav>
          {footerItems.length > 0 &&
            <footer id="footer" tabIndex={-1} className="menu-footer">
              {renderFooterLinks(footerItems)}
            </footer>
          }
        </div>
        <div className="menu-scrim" data-dismiss="menu" tabIndex="-1"></div>
      </div>
    </div>
  );
};

export default Menu;
